import { render } from "./DeluxeSidebar.vue?vue&type=template&id=de9cc37a"
import script from "./DeluxeSidebar.vue?vue&type=script&lang=js"
export * from "./DeluxeSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__